<footer id="nr_footer" class="row">
    <div class="container">
        <div class="row goTop">
            <a href="#top"><i class="fa fa-angle-up"></i></a>
        </div>

        <div class="footerWidget row">
            <div class="col-sm-6 widget">
                <div class="getInTouch_widget row">
                    <div class="widgetHeader row m0"><img src="../../../assets/images/whiteSquare.png" alt="">{{'Contactus' | translate}}</div>
                    <div class="row getInTouch_tab m0">
                        <div class="row m0 contactWidget widgetS">
                           
                            <ul class="list-unstyled">
                                <li><a href="tel:966599454045"><i class="fa fa-phone"></i> +966 59 945 4045</a></li>
                                <li><a href="mailto:info@misk-co.com"><i class="fa fa-envelope-o"></i> info@misk-co.com</a></li>
                                <li><i class="fa fa-home"></i> {{'address' | translate}}</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
            <!-- <div class="col-sm-6 widget">
                <div class="getInTouch_widget row">
                    <div class="widgetHeader row m0">
                        <img src="../../../assets/images/maplocation.png" alt="">{{'findUs' | translate}}
                    </div>
                    <div class="row getInTouch_tab m0">
                        <div id="mapBox" style="height: 180px;">

                        </div>
                    </div>
                </div>
           
            </div> -->
        </div>
        <div class="row copyrightRow">
           
            {{'Copyright' | translate}} &amp; {{'Developed' | translate}} <a target="_blank" href="http://www.aldawal.com">{{'Aldawal' | translate}}</a>
        </div>
    </div>
</footer>
